module.exports = "/assets/mobile-banner/dw.jpg?VsF73g9";